import React, { Component } from 'react';
import Lightbox from "react-image-lightbox";


import { SectionTitle, SectionDescription }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const desc = "Soluções em abrigos para equipamentos integrados com sistema de climatização, energia, esteiramentos, leitos e calhas, com e sem piso elevado.";  
const desc1 = "Nossas soluções são para abrigar equipamentos de telecomunicações, data centers e equipamentos sensíveis que necessitam de segurança e controle de temperatura. As dimensões são de acordo com a necessidade de nossos clientes totalmente montado e equipado em fábrica ou em campo onde não temos acesso, gerando, assim, velocidade nos projetos de implantação.";  
const desc2 = "Nossa fábrica esta preparada para fabricar os mais diversos modelos, bem como as dimensões. Nossos galpões são totalmente cobertos. ";  

const images = [
    process.env.PUBLIC_URL + '/assets/images/container/container-1.jpg',
    process.env.PUBLIC_URL + '/assets/images/container/container-2.jpg',
    process.env.PUBLIC_URL + '/assets/images/container/container-3.jpg',
    process.env.PUBLIC_URL + '/assets/images/container/container-4.jpg',
    process.env.PUBLIC_URL + '/assets/images/container/container-5.jpg',
    process.env.PUBLIC_URL + '/assets/images/container/container-6.jpg',
  ];


class PageInternalContainer extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        photoIndex: 0,
        isOpenLightBox: false
      };
    }

    handlePhoto = (photo) => {
        this.setState({photoIndex: photo, isOpenLightBox: true});
    }

    render() {
        const { photoIndex, isOpenLightBox } = this.state;
        return (
            <section className={ isMobile ? 'page-internal-mobile' : 'page-internal'} id="page" >
                <div className="container">
                    {SectionTitle({section: 'IDEAL BRASIL', subtitle:'CONTAINER', featured: ''})}
                    {SectionDescription(desc)}   
                    <div className="mt-50">&nbsp;</div> 

                    <div className="row">
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-1.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(0) }/>
                        </div>
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-2.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(1) }/>
                        </div>
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-3.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(2) }/>
                        </div>
                    </div> 
                    <div className="mt-50">&nbsp;</div> 
                    {SectionDescription(desc1)}  
                    {SectionDescription(desc2)}   
                    <div className="mt-50">&nbsp;</div> 
                    <div className="row">
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-4.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(3) }/>
                        </div>
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-5.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(4) }/>
                        </div>
                        <div className="col col-4 col-xs-2">
                            <img src={process.env.PUBLIC_URL + '/assets/images/container/container-6.jpg'} alt="" className="img-thumbnail img-fluid" onClick={() => this.handlePhoto(5) }/>
                        </div>
                    </div> 
                    
                    <div className="mt-50">&nbsp;</div> 
                    <h4 className="text-left">Vantagens:</h4>
                    <ul>
                        <li>Fácil montagem</li>
                        <li>Transporte</li>
                        <li>Layout customizado para cada cliente</li>
                        <li>Velocidade de fabricação e montagem</li>
                        <li>Portas de Segurança</li>
                        <li>Controle de acesso</li>
                        <li>Segurança</li>
                        <li>Sua obra não para enquanto produzimos seu container.</li>
                    </ul>

                   
                    

                </div>

                {isOpenLightBox && (
                    <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => this.setState({ isOpen: false })}
                    onMovePrevRequest={() =>
                        this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length
                        })
                    }
                    onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % images.length
                        })
                    }
                    />
                )}
            </section>
        )
    }
}

export default PageInternalContainer;
